import { z } from "zod";
import { createEndpointWithPagination } from "../createEndpoint";
import type { HttpClient } from "../httpClient";
import {
    ClientProjectsInboxItemSchema,
    ProjectsV2ListQueryParams,
} from "../schemas/projects-v2";
import { createProjectsV2CommonApi } from "./projects-v2.shared";

export function createClientProjectsV2Api(http: HttpClient, baseUrl: string) {
    const common = createProjectsV2CommonApi(http, baseUrl);
    const projectsBaseUrl = `${baseUrl}/projects`;

    return {
        /**
         * List the authenticated client's grouped V2 project inbox.
         * GET /api/v2/projects/client
         */
        listInboxProjects: createEndpointWithPagination<
            z.infer<typeof ClientProjectsInboxItemSchema>,
            unknown,
            unknown,
            ProjectsV2ListQueryParams
        >(http, "GET", "/client", {
            base: projectsBaseUrl,
            itemSchema: ClientProjectsInboxItemSchema,
        }),
        ...common,
    };
}

export type ClientProjectsV2Api = ReturnType<typeof createClientProjectsV2Api>;
